<template>
  <div>
    <!-- Backdrop -->
    <div
      v-if="modelValue"
      class="fixed inset-0 z-50 bg-gray-900 bg-opacity-50 transition-opacity"
      @click="close"
    ></div>

    <!-- Off-canvas panel -->
    <div
      :class="[
        `fixed bottom-0 top-0 z-[60] flex h-full flex-col border-s border-gray-200 bg-white
        transition-transform duration-300 ease-in-out`,
        position === 'left' ? 'left-0' : 'right-0',
        modelValue
          ? 'translate-x-0'
          : position === 'left'
            ? '-translate-x-full'
            : 'translate-x-full',
        width
      ]"
    >
      <!-- Header - Fixed -->
      <div class="flex items-center justify-between border-b border-gray-200 px-4 py-3">
        <h3 class="font-bold text-gray-800">
          <slot name="title">Menu</slot>
        </h3>
        <button
          type="button"
          class="flex h-7 w-7 items-center justify-center rounded-full border border-transparent text-sm
            font-semibold text-gray-800 hover:bg-gray-100"
          @click="close"
        >
          <span class="sr-only">Close</span>
          <svg
            class="h-4 w-4 flex-shrink-0"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      </div>

      <!-- Content - Scrollable -->
      <div class="flex-1 overflow-y-auto">
        <div class="p-4">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue'

  const props = defineProps({
    modelValue: {
      type: Boolean,
      required: true
    },
    position: {
      type: String,
      default: 'right',
      validator: (value) => ['left', 'right'].includes(value)
    },
    width: {
      type: String,
      default: 'w-80'
    }
  })

  const emit = defineEmits(['update:modelValue'])

  const close = () => {
    emit('update:modelValue', false)
  }
</script>
